<template>
    <div class="card">
        <div class="row">
            <Toast/>
            <DataTable :value="all_supplier_responsibles" :paginator="true" :rows="10"
            :paginatorTemplate="paginatorTemplate"
            :rowsPerPageOptions="[10,20,50]" responsiveLayout="scroll" scrollable
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            stripedRows :loading="loading"
            :globalFilterFields="['name']"
            v-model:filters="filters" >
                <template #header>
                    <div class="row">
                        <div class="table-header flex flex-column md:flex-row md:justify-content-end">
                            <span class="p-input-icon-left ">
                                <i class="pi pi-search" />
                                <InputText id="filter_supplier_responsible"  v-model="filters['global'].value" placeholder="Keyword Search" class="input_small"/>
                            </span>
                        </div>
                    </div>
                </template>
                <Column header="Name" field="name" :sortable="true"/>
                <Column header="Phone" field="phone" :sortable="true" style="max-width: 12rem;"/>
                <Column header="Supplier" field="id_supplier.name" :sortable="true">
                </Column> 
                <Column v-if="$can('change','supplier_responsible')" header="Edit" style="width: 7rem;">
                    <template #body="slotProps">
                        <Button data-cy="edit_button" icon="pi pi-pencil" class="p-button-rounded p-button-info p-button-outlined" @click="edit_supplier_responsible(slotProps.data)"/>
                    </template>
                </Column>
                <Column v-if="$can('delete','supplier_responsible')" header="Delete" style="width: 7rem;">
                    <template #body="slotProps">
                        <Button data-cy="delete_button" icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-outlined" @click="confirm_delete_supplier_responsible(slotProps)"/>
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>

    <Dialog data-cy="edit_supplier_responsible_modal" v-model:visible="supplier_responsible_dialog" :breakpoints="{'960px': '90vw'}" :style="{width: '50vw'}" header="Supplier responsible Details" :modal="true" class="p-fluid">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-10 md:col-12">
                    <div class="p-float-field">
                        <label for="name" class="ps-1 pb-1"> <strong> Name </strong> </label>
                        <InputText id="name" v-model.trim="supplier_responsible.name" required="true" autofocus :class="{'p-invalid': submitted && !supplier_responsible.name || supplier_responsible_errors.name}" />
                        <small v-if="Object.keys(supplier_responsible_errors).length !== 0 && supplier_responsible_errors.name" class="p-error"><span v-for="error in supplier_responsible_errors.name" :key="error">{{error}}<br></span></small>
                        <small class="p-error" v-if="submitted && !supplier_responsible.name">Name is required.</small>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-10 md:col-12">
                    <div class="p-float-field">
                        <label for="phone" class="ps-1 pb-1"> <strong> Phone </strong> </label>
                        <InputText id="phone" v-model.trim="supplier_responsible.phone" required="true" autofocus :class="{'p-invalid': submitted && !supplier_responsible.phone || supplier_responsible_errors.phone}" />
                        <small v-if="Object.keys(supplier_responsible_errors).length !== 0 && supplier_responsible_errors.phone" class="p-error"><span v-for="error in supplier_responsible_errors.phone" :key="error">{{error}}<br></span></small>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-10 md:col-12">
                    <div class="p-float-field">
                        <label for="supplier" class="ps-1 pb-1"> <strong>Supplier</strong> </label>  
                        <Dropdown id="id_supplier" v-model="supplier_responsible.id_supplier" :options="all_suppliers" optionLabel="ship_agent" :filter="true">
                            <template #value="slotProps">
                                <div v-if="slotProps.value && !slotProps.value.value">
                                    <span>{{slotProps.value.name}}</span>
                                </div>
                                <div v-else-if="slotProps.label && slotProps.value.value">
                                    <span>{{slotProps.option.name}}</span>
                                </div>
                            </template>
                            <template #option="slotProps">
                                <div>{{slotProps.option.name}} </div>
                            </template>
                        </Dropdown>
                        <small v-if="Object.keys(supplier_responsible_errors).length !== 0 && supplier_responsible_errors.id_supplier" class="p-error"><span v-for="error in supplier_responsible_errors.id_supplier" :key="error">{{error}}<br></span></small>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Cancel" class="p-button-text" @click="hide_supplier_responsible_dialog"/>
            <Button data-cy="save_edit_supplier_responsible" label="Save" @click="save_supplier_responsible" />
        </template>
    </Dialog>

    <Dialog v-model:visible="delete_supplier_responsible_dialog" :style="{width: '450px'}" header="Confirm" :modal="true">
        <div class="confirmation-content">
            <span v-if="supplier_responsible">Are you sure you want to delete <b>{{supplier_responsible.name}}</b>?</span>
        </div>
        <template #footer>
            <Button label="No" class="p-button-text" @click="delete_supplier_responsible_dialog = false"/>
            <Button data-cy="confirm_delete_button" label="Yes" @click="deleteSupplier_responsible" />
        </template>
    </Dialog>

</template>

<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext';
import Button from 'primevue/button'
import Toast from 'primevue/toast'
import Dialog from 'primevue/dialog'
import Dropdown from 'primevue/dropdown'
import { FilterMatchMode } from 'primevue/api';
import { required } from '@vuelidate/validators'
import { useVuelidate } from "@vuelidate/core";

export default {
    setup: () => ({ v$: useVuelidate() }),
    name: "TableSupplier_responsibles",    
    components: {
        DataTable,
        Column,
        Dropdown,
        InputText,
        Button,
        Toast,
        Dialog,
    },
    data() {
        return {
            supplier_responsible: {},
            supplier_responsible_errors: {},
            supplier_responsible_dialog: false,
            delete_supplier_responsible_dialog: false,
            submitted: false,
            filters: {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            },
            loading: false,
            paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        }
    },
    async mounted() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
        if(this.all_supplier_responsibles.length == 0) {
            this.loading = true
            await this.$store.dispatch('load_all_supplier_responsibles')
            await this.$store.dispatch('load_all_suppliers')
            this.loading = false
        }
    },

    async unmounted(){
        window.removeEventListener('resize', this.handleResize);
    },

    computed: {
        all_supplier_responsibles: function() {
            return this.$store.getters.all_supplier_responsibles
        },
        all_suppliers: function(){
            return this.$store.getters.all_suppliers
        },
        get_supplier_responsible_errors: function() {
            return this.$store.getters.get_supplier_responsible_errors
        },
        get_delete_supplier_responsible_status: function() {
            return this.$store.getters.get_delete_supplier_responsible_status
        }
    },
    methods: {

        async handleResize(){
            if (window.innerWidth <= 767){
                this.paginatorTemplate = "CurrentPageReport PrevPageLink NextPageLink"
            } else {
                this.paginatorTemplate = "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            }
        },

        confirm_delete_supplier_responsible(supplier_responsible) {
            this.supplier_responsible = supplier_responsible.data;
            this.delete_supplier_responsible_dialog = true;
        },
        async deleteSupplier_responsible() {
            await this.$store.dispatch('delete_supplier_responsible', this.supplier_responsible.id)
            if (!this.get_delete_supplier_responsible_status){
                this.$toast.removeAllGroups();
                this.$toast.add({severity:'success', summary: 'Successful', detail: 'Supplier responsible deleted', life: 3000});
            }else{
                this.$toast.removeAllGroups();
                this.$toast.add({severity:'error', summary: 'Error', detail: "Supplier responsible can't be deleted", life: 3000});
            }
            this.delete_supplier_responsible_dialog = false;
            
        },
        edit_supplier_responsible(supplier_responsible) {
            this.supplier_responsible = {...supplier_responsible};
            this.supplier_responsible_dialog = true;
            
        },
        async save_supplier_responsible() {
            this.submitted = true;
			if (this.supplier_responsible.name.trim()) {

                await this.$store.dispatch('update_supplier_responsible', this.supplier_responsible)
                this.supplier_responsible_errors = this.get_supplier_responsible_errors
                if(Object.keys(this.supplier_responsible_errors).length === 0){
                    this.hide_supplier_responsible_dialog()
                    this.supplier_responsible = {};
                    this.$toast.add({severity:'success', summary: 'Successful', detail: 'Supplier responsible modified', life: 3000});
                }
            }
        },
        hide_supplier_responsible_dialog() {
            this.supplier_responsible_dialog = false;
            this.submitted = false;
        },
    },
    validations() {
        return {
            name: { required },
            phone: { required },
            id_supplier: { required },
        }
    },
}
</script>

<style scoped>
.card {
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12);
    border-radius: 10px;
    margin-bottom: 1rem;
}

.table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}

:deep(.p-inputtext){
    font-size: 1rem;
    margin: auto;
}

.input_small{
    font-size: .8rem !important; 
}

</style>